export default __webpack_public_path__ + "static/media/bea16855fe6b8581fab5368daa2dc37.1dc52851.png";